import { render, staticRenderFns } from "./news_composite_list.vue?vue&type=template&id=2eb831db&scoped=true&"
import script from "./news_composite_list.vue?vue&type=script&lang=js&"
export * from "./news_composite_list.vue?vue&type=script&lang=js&"
import style0 from "./news_composite_list.vue?vue&type=style&index=0&id=2eb831db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb831db",
  null
  
)

export default component.exports